export var TypeActionQuest;
(function (TypeActionQuest) {
    TypeActionQuest["Update"] = "Quest > Update";
    TypeActionQuest["Finish"] = "Quest > Finish";
    TypeActionQuest["Skip"] = "Quest > Skip";
    TypeActionQuest["Select"] = "Quest > Select";
    TypeActionQuest["Open"] = "Quest > Open";
    TypeActionQuest["Visited"] = "Quest > Visited";
})(TypeActionQuest || (TypeActionQuest = {}));
export var actionQuestUpdate = function (questIds) { return ({
    questIds: questIds,
    type: TypeActionQuest.Update,
}); };
export var actionQuestFinish = function (questId) { return ({
    questId: questId,
    type: TypeActionQuest.Finish,
}); };
export var actionQuestSkip = function (questId, taskIndex, amount, itemId) { return ({
    amount: amount,
    itemId: itemId,
    questId: questId,
    taskIndex: taskIndex,
    type: TypeActionQuest.Skip,
}); };
export var actionQuestSelect = function (quest) { return ({
    quest: quest,
    type: TypeActionQuest.Select,
}); };
export var actionQuestOpen = function (questId, questIds) { return ({
    questId: questId,
    questIds: questIds,
    type: TypeActionQuest.Open,
}); };
export var actionQuestVisited = function (questId) { return ({
    questId: questId,
    type: TypeActionQuest.Visited,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/actionQuests.ts
// module id = 115
// module chunks = 3